import SlideshowWidgetContainer from './SlideshowWidgetContainer';
import { Config } from './types';
import SlideshowWidgetControl from 'shared/widgets/Slideshow/SlideshowWidgetControl';
import {
  defaultSlidesData,
  defaultBackgroundData,
  defaultBackgroundImageData,
  defaultBorderData,
  defaultPaddingData,
  defaultSizeLocationData,
  widgetTypes,
} from 'builder/util/constants';

export default {
  type: widgetTypes.Slideshow,
  displayName: 'Slideshow',
  icon: 'Slideshow',
  initialConfig: {
    ...defaultSizeLocationData,
    ...defaultBackgroundData,
    ...defaultBackgroundImageData,
    ...defaultPaddingData,
    ...defaultBorderData,
    ...defaultSlidesData,
    uniqueId: '123abc',
    lineColor: 'red',
    width: 1200,
    height: 331,
    currentSlideIndex: 0,
    visible: true,
  },
  components: {
    render: SlideshowWidgetContainer,
    control: SlideshowWidgetControl,
  },
  copyable: true,
} as HorizonWidgetDefinition<Config>;
